/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ClaimStreakResponse, ClaimStreakVars } from '../openapi-types.gen.js';

export type { ClaimStreakResponse, ClaimStreakVars } from '../openapi-types.gen.js';

export const useClaimStreak = createMutationHook<ClaimStreakVars, ClaimStreakResponse, unknown>({
  specName: 'useClaimStreak',
  path: '/v1/rewards/streak/claim',
  method: 'POST',
  resolveUrl: (vars: ClaimStreakVars) => `/v1/rewards/streak/claim`,
  
  parseResponse: (raw: unknown): ClaimStreakResponse => raw as ClaimStreakResponse,
  
  
  
});
